module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('section', [_c('el-col', {
    staticClass: "toolbar",
    staticStyle: {
      "padding-bottom": "10px"
    },
    attrs: {
      "span": 24
    }
  }, [_c('el-button', {
    on: {
      "click": _vm.handleAdd
    }
  }, [_vm._v("添加新用户")]), _vm._v(" "), _c('el-button', {
    on: {
      "click": _vm.handleBatchImport
    }
  }, [_vm._v("批量导入")]), _vm._v(" "), _c('el-button', {
    on: {
      "click": _vm.exportData
    }
  }, [_vm._v("数据导出")]), _vm._v(" "), _c('el-input', {
    staticStyle: {
      "width": "30%",
      "float": "right"
    },
    attrs: {
      "placeholder": "请输入中英文名称或项目名称"
    },
    model: {
      value: (_vm.search_word),
      callback: function($$v) {
        _vm.search_word = $$v
      },
      expression: "search_word"
    }
  }, [_c('el-button', {
    attrs: {
      "slot": "append",
      "icon": "search"
    },
    on: {
      "click": _vm.handleSearch
    },
    slot: "append"
  })], 1)], 1), _vm._v(" "), _c('el-dialog', {
    attrs: {
      "title": "批量导入用户"
    },
    on: {
      "close": _vm.cancelUpload
    },
    model: {
      value: (_vm.batchImportDialogVisible),
      callback: function($$v) {
        _vm.batchImportDialogVisible = $$v
      },
      expression: "batchImportDialogVisible"
    }
  }, [_c('el-upload', {
    ref: "batchImportUpload",
    attrs: {
      "limit": 1,
      "on-exceed": _vm.handleUploadExceed,
      "action": _vm.uploadUrl,
      "on-success": _vm.handleUploadSuccess,
      "on-error": _vm.handleUploadError,
      "before-upload": _vm.handleBeforeUpload,
      "headers": _vm.uploadHeader,
      "auto-upload": false
    }
  }, [_c('span', [_vm._v("选取文件:    ")]), _c('el-button', {
    attrs: {
      "size": "small",
      "type": "primary"
    }
  }, [_vm._v("请选择")]), _vm._v(" "), _c('a', {
    staticStyle: {
      "display": "inline",
      "padding-left": "350px",
      "color": "#b0b1b3",
      "text-decoration": "underline"
    },
    on: {
      "click": function($event) {
        $event.stopPropagation();
        $event.preventDefault();
        return _vm.downloadTemplate($event)
      }
    }
  }, [_vm._v("模版下载")]), _vm._v(" "), _c('div', {
    staticClass: "el-upload__tip",
    staticStyle: {
      "margin-top": "55px"
    },
    attrs: {
      "slot": "tip"
    },
    slot: "tip"
  }, [_vm._v("温馨提示:只能上传excel文件，且不超过20MB")])], 1), _vm._v(" "), _c('div', {
    staticClass: "dialog-footer",
    attrs: {
      "slot": "footer"
    },
    slot: "footer"
  }, [_c('el-button', {
    on: {
      "click": _vm.cancelUpload
    }
  }, [_vm._v("取 消")]), _vm._v(" "), _c('el-button', {
    attrs: {
      "type": "primary"
    },
    on: {
      "click": _vm.batchImportOnSubmit
    }
  }, [_vm._v("确 定")])], 1)], 1), _vm._v(" "), _c('el-table', {
    directives: [{
      name: "loading",
      rawName: "v-loading",
      value: (_vm.listLoading),
      expression: "listLoading"
    }],
    staticStyle: {
      "width": "100%"
    },
    attrs: {
      "data": _vm.list_data,
      "size": "mini",
      "highlight-current-row": ""
    },
    on: {
      "selection-change": _vm.selsChange
    }
  }, [_c('el-table-column', {
    attrs: {
      "type": "index",
      "width": "50"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "userNameCn",
      "label": "中文名称",
      "width": "100",
      "sortable": ""
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "userNameEn",
      "label": "英文名称",
      "width": "120",
      "sortable": ""
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "roleTypeName",
      "label": "用户类型",
      "width": "100",
      "sortable": ""
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "cityName",
      "label": "城市",
      "width": "100",
      "sortable": ""
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "businessGroupNames",
      "label": "所属业务组",
      "width": "100",
      "sortable": ""
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "projectNames",
      "label": "管理项目",
      "width": "100",
      "sortable": ""
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [(scope.row.roleType == 1) ? _c('span') : _c('span', [_vm._v(_vm._s(scope.row.projectNames))])]
      }
    }])
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "userPosition",
      "label": "职位",
      "width": "120",
      "sortable": ""
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "roleName",
      "label": "用户权限",
      "min-width": "90",
      "sortable": ""
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "account",
      "label": "邮箱",
      "min-width": "100",
      "sortable": ""
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "mobilePhone",
      "label": "移动电话号",
      "min-width": "100",
      "sortable": ""
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [(scope.row.mobilePrefix) ? _c('span', [_vm._v(_vm._s(scope.row.mobilePrefix) + "-" + _vm._s(scope.row.mobilePhone))]) : _c('span', [_vm._v(_vm._s(scope.row.mobilePhone))])]
      }
    }])
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "acceptTimeStr",
      "label": "隐私协议确认",
      "min-width": "120",
      "sortable": ""
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "acceptAgreementVersion",
      "label": "隐私协议版本",
      "min-width": "120",
      "sortable": ""
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": "操作",
      "width": "200"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_c('el-button', {
          attrs: {
            "size": "small"
          },
          on: {
            "click": function($event) {
              _vm.handleEdit(scope.$index, scope.row)
            }
          }
        }, [_vm._v("修改")]), _vm._v(" "), _c('el-button', {
          attrs: {
            "size": "small"
          },
          on: {
            "click": function($event) {
              _vm.handlePasswordReset(scope.$index, scope.row)
            }
          }
        }, [_vm._v("密码重置")]), _vm._v(" "), _c('el-button', {
          attrs: {
            "size": "small"
          },
          on: {
            "click": function($event) {
              _vm.handleDeleteOne(scope.$index, scope.row)
            }
          }
        }, [_vm._v("删除")])]
      }
    }])
  })], 1), _vm._v(" "), _c('el-dialog', {
    attrs: {
      "title": "管理员确认"
    },
    on: {
      "close": _vm.cancelResetPswSubmit
    },
    model: {
      value: (_vm.resetPswDialogVisible),
      callback: function($$v) {
        _vm.resetPswDialogVisible = $$v
      },
      expression: "resetPswDialogVisible"
    }
  }, [_c('el-form', {
    ref: "resetPswForm",
    attrs: {
      "model": _vm.resetPswForm,
      "rules": _vm.resetPswFormRules
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": "管理员密码",
      "prop": "adminPwd",
      "label-width": "100px"
    }
  }, [_c('el-input', {
    attrs: {
      "type": "password",
      "auto-complete": "off"
    },
    model: {
      value: (_vm.resetPswForm.adminPwd),
      callback: function($$v) {
        _vm.$set(_vm.resetPswForm, "adminPwd", $$v)
      },
      expression: "resetPswForm.adminPwd"
    }
  })], 1)], 1), _vm._v(" "), _c('div', {
    staticClass: "dialog-footer",
    attrs: {
      "slot": "footer"
    },
    slot: "footer"
  }, [_c('el-button', {
    on: {
      "click": _vm.cancelResetPswSubmit
    }
  }, [_vm._v("取 消")]), _vm._v(" "), _c('el-button', {
    attrs: {
      "disabled": _vm.resetPswButtonDisabled,
      "type": "primary"
    },
    on: {
      "click": _vm.resetPswFormOnSubmit
    }
  }, [_vm._v("确 定")])], 1)], 1), _vm._v(" "), _c('el-col', {
    staticClass: "toolbar",
    attrs: {
      "span": 24
    }
  }, [_c('el-pagination', {
    staticStyle: {
      "float": "right"
    },
    attrs: {
      "layout": "prev, pager, next",
      "page-size": 15,
      "total": _vm.total
    },
    on: {
      "current-change": _vm.handleCurrentChange
    }
  })], 1), _vm._v(" "), _c('el-dialog', {
    attrs: {
      "title": "编辑",
      "close-on-click-modal": false
    },
    model: {
      value: (_vm.editFormVisible),
      callback: function($$v) {
        _vm.editFormVisible = $$v
      },
      expression: "editFormVisible"
    }
  }, [_c('el-form', {
    ref: "editForm",
    attrs: {
      "model": _vm.editForm,
      "label-width": "120px",
      "rules": _vm.editFormRules
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": "用户类型",
      "prop": "roleType"
    }
  }, [_c('el-radio-group', {
    attrs: {
      "change": _vm.handleRoleTypeChange('edit', _vm.addForm.roleType)
    },
    model: {
      value: (_vm.editForm.roleType),
      callback: function($$v) {
        _vm.$set(_vm.editForm, "roleType", $$v)
      },
      expression: "editForm.roleType"
    }
  }, [_c('el-radio', {
    staticClass: "radio",
    attrs: {
      "label": 0
    }
  }, [_vm._v("JLL用户")]), _vm._v(" "), _c('el-radio', {
    staticClass: "radio",
    attrs: {
      "label": 1
    }
  }, [_vm._v("客户")])], 1)], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "中文姓名",
      "prop": "userNameCn"
    }
  }, [_c('el-input', {
    attrs: {
      "auto-complete": "off"
    },
    model: {
      value: (_vm.editForm.userNameCn),
      callback: function($$v) {
        _vm.$set(_vm.editForm, "userNameCn", $$v)
      },
      expression: "editForm.userNameCn"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "英文姓名",
      "prop": "userNameEn"
    }
  }, [_c('el-input', {
    attrs: {
      "auto-complete": "off"
    },
    model: {
      value: (_vm.editForm.userNameEn),
      callback: function($$v) {
        _vm.$set(_vm.editForm, "userNameEn", $$v)
      },
      expression: "editForm.userNameEn"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "中英文显示",
      "prop": "nameModel"
    }
  }, [_c('el-radio-group', {
    model: {
      value: (_vm.editForm.nameModel),
      callback: function($$v) {
        _vm.$set(_vm.editForm, "nameModel", $$v)
      },
      expression: "editForm.nameModel"
    }
  }, [_c('el-radio', {
    staticClass: "radio",
    attrs: {
      "label": 0
    }
  }, [_vm._v("中文")]), _vm._v(" "), _c('el-radio', {
    staticClass: "radio",
    attrs: {
      "label": 1
    }
  }, [_vm._v("英文")])], 1)], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "移动电话号",
      "prop": "mobilePhone"
    }
  }, [_c('el-select', {
    staticStyle: {
      "width": "80px",
      "dispaly": "inline"
    },
    model: {
      value: (_vm.editForm.mobilePrefix),
      callback: function($$v) {
        _vm.$set(_vm.editForm, "mobilePrefix", $$v)
      },
      expression: "editForm.mobilePrefix"
    }
  }, _vm._l((_vm.mobilePrefixList), function(i) {
    return _c('el-option', {
      attrs: {
        "label": i.name,
        "value": i.code
      }
    })
  })), _vm._v(" "), _c('span', [_vm._v("-")]), _vm._v(" "), _c('el-input', {
    staticStyle: {
      "width": "380px",
      "dispaly": "inline"
    },
    attrs: {
      "auto-complete": "off"
    },
    model: {
      value: (_vm.editForm.mobilePhone),
      callback: function($$v) {
        _vm.$set(_vm.editForm, "mobilePhone", $$v)
      },
      expression: "editForm.mobilePhone"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "邮箱",
      "prop": "email"
    }
  }, [_c('el-input', {
    attrs: {
      "auto-complete": "off"
    },
    model: {
      value: (_vm.editForm.email),
      callback: function($$v) {
        _vm.$set(_vm.editForm, "email", $$v)
      },
      expression: "editForm.email"
    }
  })], 1), _vm._v(" "), (_vm.editForm.roleType == 1) ? _c('el-form-item', {
    staticStyle: {
      "width": "240px"
    },
    attrs: {
      "label": "账户有效期",
      "prop": "expirationTime"
    }
  }, [_c('el-date-picker', {
    staticStyle: {
      "width": "240px"
    },
    attrs: {
      "type": "date",
      "placeholder": "请选择"
    },
    on: {
      "change": _vm.handleEditFormExpirationTime
    },
    model: {
      value: (_vm.editForm.expirationTime),
      callback: function($$v) {
        _vm.$set(_vm.editForm, "expirationTime", $$v)
      },
      expression: "editForm.expirationTime"
    }
  })], 1) : _vm._e(), _vm._v(" "), (_vm.editForm.roleType == 1) ? _c('el-form-item', {
    attrs: {
      "label": "担保用户"
    }
  }, [_c('el-select', {
    staticStyle: {
      "width": "240px"
    },
    attrs: {
      "filterable": "",
      "remote": "",
      "reserve-keyword": "",
      "remote-method": _vm.getWarrantAcountList,
      "placeholder": "请输入用户名搜索"
    },
    on: {
      "change": function($event) {
        _vm.handleGetRelationProjectList('edit', _vm.editForm.warrantAccount)
      }
    },
    model: {
      value: (_vm.editForm.warrantAccount),
      callback: function($$v) {
        _vm.$set(_vm.editForm, "warrantAccount", $$v)
      },
      expression: "editForm.warrantAccount"
    }
  }, _vm._l((_vm.warrantAcountList), function(i) {
    return _c('el-option', {
      key: i.id,
      attrs: {
        "label": i.name,
        "value": i.id
      }
    })
  }))], 1) : _vm._e(), _vm._v(" "), (_vm.editForm.roleType == 1) ? _c('el-form-item', {
    attrs: {
      "prop": "projectIds",
      "label": "关联项目"
    }
  }, [_c('div', [_c('treeselect', {
    staticStyle: {
      "width": "240px"
    },
    attrs: {
      "options": _vm.relationProjectList,
      "load-root-options": _vm.loadRootOptions,
      "treeMark": _vm.treeMark,
      "auto-load-root-options": false,
      "multiple": true,
      "placeholder": "请选择",
      "noOptionsText": "暂无可关联的项目"
    },
    model: {
      value: (_vm.editForm.projectIds),
      callback: function($$v) {
        _vm.$set(_vm.editForm, "projectIds", $$v)
      },
      expression: "editForm.projectIds"
    }
  })], 1)]) : _vm._e(), _vm._v(" "), (_vm.editForm.roleType == '0') ? _c('el-form-item', {
    attrs: {
      "label": "职位",
      "prop": "userPosition"
    }
  }, [_c('el-input', {
    attrs: {
      "auto-complete": "off"
    },
    model: {
      value: (_vm.editForm.userPosition),
      callback: function($$v) {
        _vm.$set(_vm.editForm, "userPosition", $$v)
      },
      expression: "editForm.userPosition"
    }
  })], 1) : _vm._e(), _vm._v(" "), (_vm.editForm.roleType == '0') ? _c('el-form-item', {
    attrs: {
      "label": "城市",
      "prop": "city"
    }
  }, [_c('el-select', {
    staticStyle: {
      "width": "240px"
    },
    attrs: {
      "filterable": "",
      "remote": "",
      "reserve-keyword": "",
      "remote-method": _vm.getRegionAreaList,
      "placeholder": "请输入城市名称搜索"
    },
    model: {
      value: (_vm.editForm.city),
      callback: function($$v) {
        _vm.$set(_vm.editForm, "city", $$v)
      },
      expression: "editForm.city"
    }
  }, _vm._l((_vm.regionAreaList), function(i) {
    return _c('el-option', {
      attrs: {
        "label": i.name,
        "value": i.id
      }
    })
  }))], 1) : _vm._e(), _vm._v(" "), (_vm.editForm.roleType == '0') ? _c('el-form-item', {
    attrs: {
      "label": "用户权限",
      "prop": "roleIdentity"
    }
  }, [_c('el-select', {
    staticStyle: {
      "width": "140px"
    },
    model: {
      value: (_vm.editForm.roleIdentity),
      callback: function($$v) {
        _vm.$set(_vm.editForm, "roleIdentity", $$v)
      },
      expression: "editForm.roleIdentity"
    }
  }, _vm._l((_vm.accountRoleList), function(i) {
    return _c('el-option', {
      attrs: {
        "label": i.roleName,
        "value": i.identity
      }
    })
  }))], 1) : _vm._e(), _vm._v(" "), (_vm.editForm.roleIdentity == 'level-one' && _vm.editForm.roleType == '0') ? _c('el-form-item', {
    attrs: {
      "label": "大区",
      "prop": "regionCode"
    }
  }, [_c('el-select', {
    staticStyle: {
      "width": "240px"
    },
    model: {
      value: (_vm.editForm.regionCode),
      callback: function($$v) {
        _vm.$set(_vm.editForm, "regionCode", $$v)
      },
      expression: "editForm.regionCode"
    }
  }, _vm._l((_vm.regionList), function(i) {
    return _c('el-option', {
      attrs: {
        "label": i.name,
        "value": i.code
      }
    })
  }))], 1) : _vm._e(), _vm._v(" "), (_vm.editForm.roleIdentity == 'level-three' && _vm.editForm.roleType == '0') ? _c('el-form-item', {
    attrs: {
      "label": "项目权限",
      "prop": "projectIdArray"
    }
  }, [_c('div', [_c('treeselect', {
    staticStyle: {
      "width": "240px"
    },
    attrs: {
      "multiple": true,
      "options": _vm.projectTree,
      "disable-branch-nodes": true
    },
    model: {
      value: (_vm.editForm.projectIdArray),
      callback: function($$v) {
        _vm.$set(_vm.editForm, "projectIdArray", $$v)
      },
      expression: "editForm.projectIdArray"
    }
  })], 1)]) : _vm._e(), _vm._v(" "), (_vm.editForm.roleIdentity == 'level-two' && _vm.editForm.roleType == '0') ? _c('el-form-item', {
    attrs: {
      "label": "业务组权限",
      "prop": "businessGroupIds"
    }
  }, [_c('el-select', {
    staticStyle: {
      "width": "140px"
    },
    attrs: {
      "placeholder": _vm.editForm.businessGroupNames
    },
    on: {
      "change": _vm.handleSelect
    },
    model: {
      value: (_vm.businessGroupIdsSelect),
      callback: function($$v) {
        _vm.businessGroupIdsSelect = $$v
      },
      expression: "businessGroupIdsSelect"
    }
  }, _vm._l((_vm.bussiessGroupBriefList), function(i) {
    return _c('el-option', {
      attrs: {
        "label": i.name,
        "value": i.id
      }
    })
  }))], 1) : _vm._e()], 1), _vm._v(" "), _c('div', {
    staticClass: "dialog-footer",
    attrs: {
      "slot": "footer"
    },
    slot: "footer"
  }, [_c('el-button', {
    nativeOn: {
      "click": function($event) {
        _vm.editFormVisible = false
      }
    }
  }, [_vm._v("取消")]), _vm._v(" "), _c('el-button', {
    attrs: {
      "type": "primary",
      "disabled": _vm.editSubmitButtonDisabled,
      "loading": _vm.editLoading
    },
    nativeOn: {
      "click": function($event) {
        return _vm.editSubmit($event)
      }
    }
  }, [_vm._v("提交")])], 1)], 1), _vm._v(" "), _c('el-dialog', {
    attrs: {
      "title": "添加新用户",
      "close-on-click-modal": false
    },
    on: {
      "close": _vm.cancelAddSubmit
    },
    model: {
      value: (_vm.addFormVisible),
      callback: function($$v) {
        _vm.addFormVisible = $$v
      },
      expression: "addFormVisible"
    }
  }, [_c('el-form', {
    ref: "addForm",
    attrs: {
      "model": _vm.addForm,
      "label-width": "120px",
      "rules": _vm.addFormRules
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": "用户类型",
      "prop": "roleType"
    }
  }, [_c('el-radio-group', {
    attrs: {
      "change": _vm.handleRoleTypeChange('add', _vm.addForm.roleType)
    },
    model: {
      value: (_vm.addForm.roleType),
      callback: function($$v) {
        _vm.$set(_vm.addForm, "roleType", $$v)
      },
      expression: "addForm.roleType"
    }
  }, [_c('el-radio', {
    staticClass: "radio",
    attrs: {
      "label": 0
    }
  }, [_vm._v("JLL用户")]), _vm._v(" "), _c('el-radio', {
    staticClass: "radio",
    attrs: {
      "label": 1
    }
  }, [_vm._v("客户")])], 1)], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "中文姓名",
      "prop": "userNameCn"
    }
  }, [_c('el-input', {
    attrs: {
      "auto-complete": "off"
    },
    model: {
      value: (_vm.addForm.userNameCn),
      callback: function($$v) {
        _vm.$set(_vm.addForm, "userNameCn", $$v)
      },
      expression: "addForm.userNameCn"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "英文姓名",
      "prop": "userNameEn"
    }
  }, [_c('el-input', {
    attrs: {
      "auto-complete": "off"
    },
    model: {
      value: (_vm.addForm.userNameEn),
      callback: function($$v) {
        _vm.$set(_vm.addForm, "userNameEn", $$v)
      },
      expression: "addForm.userNameEn"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "中英文显示",
      "prop": "nameModel"
    }
  }, [_c('el-radio-group', {
    model: {
      value: (_vm.addForm.nameModel),
      callback: function($$v) {
        _vm.$set(_vm.addForm, "nameModel", $$v)
      },
      expression: "addForm.nameModel"
    }
  }, [_c('el-radio', {
    staticClass: "radio",
    attrs: {
      "label": 0
    }
  }, [_vm._v("中文")]), _vm._v(" "), _c('el-radio', {
    staticClass: "radio",
    attrs: {
      "label": 1
    }
  }, [_vm._v("英文")])], 1)], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "移动电话号",
      "prop": "mobilePhone"
    }
  }, [_c('el-select', {
    staticStyle: {
      "width": "80px",
      "dispaly": "inline"
    },
    model: {
      value: (_vm.addForm.mobilePrefix),
      callback: function($$v) {
        _vm.$set(_vm.addForm, "mobilePrefix", $$v)
      },
      expression: "addForm.mobilePrefix"
    }
  }, _vm._l((_vm.mobilePrefixList), function(i) {
    return _c('el-option', {
      attrs: {
        "label": i.name,
        "value": i.code
      }
    })
  })), _vm._v(" "), _c('span', [_vm._v("-")]), _vm._v(" "), _c('el-input', {
    staticStyle: {
      "width": "380px",
      "dispaly": "inline"
    },
    attrs: {
      "auto-complete": "off"
    },
    model: {
      value: (_vm.addForm.mobilePhone),
      callback: function($$v) {
        _vm.$set(_vm.addForm, "mobilePhone", $$v)
      },
      expression: "addForm.mobilePhone"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "邮箱",
      "prop": "email"
    }
  }, [_c('el-input', {
    attrs: {
      "auto-complete": "off"
    },
    model: {
      value: (_vm.addForm.email),
      callback: function($$v) {
        _vm.$set(_vm.addForm, "email", $$v)
      },
      expression: "addForm.email"
    }
  })], 1), _vm._v(" "), (_vm.addForm.roleType == 1) ? _c('el-form-item', {
    staticStyle: {
      "width": "240px"
    },
    attrs: {
      "label": "账户有效期",
      "prop": "expirationTime"
    }
  }, [_c('el-date-picker', {
    staticStyle: {
      "width": "240px"
    },
    attrs: {
      "type": "date",
      "placeholder": "请选择"
    },
    on: {
      "change": _vm.handleAddFormExpirationTime
    },
    model: {
      value: (_vm.addForm.expirationTime),
      callback: function($$v) {
        _vm.$set(_vm.addForm, "expirationTime", $$v)
      },
      expression: "addForm.expirationTime"
    }
  })], 1) : _vm._e(), _vm._v(" "), (_vm.addForm.roleType == 1) ? _c('el-form-item', {
    attrs: {
      "prop": "warrantAccount",
      "label": "担保用户"
    }
  }, [_c('el-select', {
    staticStyle: {
      "width": "240px"
    },
    attrs: {
      "filterable": "",
      "remote": "",
      "reserve-keyword": "",
      "remote-method": _vm.getWarrantAcountList,
      "placeholder": "请输入用户名搜索"
    },
    on: {
      "change": function($event) {
        _vm.handleGetRelationProjectList('add', _vm.addForm.warrantAccount)
      }
    },
    model: {
      value: (_vm.addForm.warrantAccount),
      callback: function($$v) {
        _vm.$set(_vm.addForm, "warrantAccount", $$v)
      },
      expression: "addForm.warrantAccount"
    }
  }, _vm._l((_vm.warrantAcountList), function(i) {
    return _c('el-option', {
      key: i.id,
      attrs: {
        "label": i.name,
        "value": i.id
      }
    })
  }))], 1) : _vm._e(), _vm._v(" "), (_vm.addForm.roleType == 1) ? _c('el-form-item', {
    attrs: {
      "prop": "projectIds",
      "label": "关联项目"
    }
  }, [_c('div', [_c('treeselect', {
    staticStyle: {
      "width": "240px"
    },
    attrs: {
      "load-root-options": _vm.loadRootOptions,
      "treeMark": _vm.treeMark,
      "auto-load-root-options": false,
      "multiple": true,
      "placeholder": "请选择",
      "noOptionsText": "暂无可关联的项目"
    },
    model: {
      value: (_vm.addForm.projectIds),
      callback: function($$v) {
        _vm.$set(_vm.addForm, "projectIds", $$v)
      },
      expression: "addForm.projectIds"
    }
  })], 1)]) : _vm._e(), _vm._v(" "), (_vm.addForm.roleType == '0') ? _c('el-form-item', {
    attrs: {
      "label": "职位",
      "prop": "userPosition"
    }
  }, [_c('el-input', {
    attrs: {
      "auto-complete": "off"
    },
    model: {
      value: (_vm.addForm.userPosition),
      callback: function($$v) {
        _vm.$set(_vm.addForm, "userPosition", $$v)
      },
      expression: "addForm.userPosition"
    }
  })], 1) : _vm._e(), _vm._v(" "), (_vm.addForm.roleType == '0') ? _c('el-form-item', {
    attrs: {
      "label": "城市",
      "prop": "city"
    }
  }, [_c('el-select', {
    staticStyle: {
      "width": "240px"
    },
    attrs: {
      "filterable": "",
      "remote": "",
      "reserve-keyword": "",
      "remote-method": _vm.getRegionAreaList,
      "placeholder": "请输入城市名称搜索"
    },
    model: {
      value: (_vm.addForm.city),
      callback: function($$v) {
        _vm.$set(_vm.addForm, "city", $$v)
      },
      expression: "addForm.city"
    }
  }, _vm._l((_vm.regionAreaList), function(i) {
    return _c('el-option', {
      attrs: {
        "label": i.name,
        "value": i.id
      }
    })
  }))], 1) : _vm._e(), _vm._v(" "), (_vm.addForm.roleType == '0') ? _c('el-form-item', {
    attrs: {
      "label": "用户权限",
      "prop": "roleIdentity"
    }
  }, [_c('el-select', {
    staticStyle: {
      "width": "240px"
    },
    model: {
      value: (_vm.addForm.roleIdentity),
      callback: function($$v) {
        _vm.$set(_vm.addForm, "roleIdentity", $$v)
      },
      expression: "addForm.roleIdentity"
    }
  }, _vm._l((_vm.accountRoleList), function(i) {
    return _c('el-option', {
      attrs: {
        "label": i.roleName,
        "value": i.identity
      }
    })
  }))], 1) : _vm._e(), _vm._v(" "), (_vm.addForm.roleIdentity == 'level-one' && _vm.addForm.roleType == '0') ? _c('el-form-item', {
    attrs: {
      "label": "大区",
      "prop": "regionCode"
    }
  }, [_c('el-select', {
    staticStyle: {
      "width": "240px"
    },
    model: {
      value: (_vm.addForm.regionCode),
      callback: function($$v) {
        _vm.$set(_vm.addForm, "regionCode", $$v)
      },
      expression: "addForm.regionCode"
    }
  }, _vm._l((_vm.regionList), function(i) {
    return _c('el-option', {
      attrs: {
        "label": i.name,
        "value": i.code
      }
    })
  }))], 1) : _vm._e(), _vm._v(" "), (_vm.addForm.roleIdentity == 'level-three' && _vm.addForm.roleType == '0') ? _c('el-form-item', {
    attrs: {
      "label": "项目权限",
      "prop": "projectIdArray"
    }
  }, [_c('div', [_c('treeselect', {
    staticStyle: {
      "width": "240px"
    },
    attrs: {
      "multiple": true,
      "options": _vm.projectTree,
      "disable-branch-nodes": true,
      "placeholder": "请选择项目"
    },
    model: {
      value: (_vm.addForm.projectIdArray),
      callback: function($$v) {
        _vm.$set(_vm.addForm, "projectIdArray", $$v)
      },
      expression: "addForm.projectIdArray"
    }
  })], 1)]) : _vm._e(), _vm._v(" "), (_vm.addForm.roleIdentity == 'level-two' && _vm.addForm.roleType == '0') ? _c('el-form-item', {
    attrs: {
      "label": "业务组权限",
      "prop": "businessGroupIds"
    }
  }, [_c('el-select', {
    staticStyle: {
      "width": "140px"
    },
    model: {
      value: (_vm.addForm.businessGroupIds),
      callback: function($$v) {
        _vm.$set(_vm.addForm, "businessGroupIds", $$v)
      },
      expression: "addForm.businessGroupIds"
    }
  }, _vm._l((_vm.bussiessGroupBriefList), function(i) {
    return _c('el-option', {
      attrs: {
        "label": i.name,
        "value": i.id
      }
    })
  }))], 1) : _vm._e()], 1), _vm._v(" "), _c('div', {
    staticClass: "dialog-footer",
    attrs: {
      "slot": "footer"
    },
    slot: "footer"
  }, [_c('el-button', {
    nativeOn: {
      "click": function($event) {
        return _vm.cancelAddSubmit($event)
      }
    }
  }, [_vm._v("取消")]), _vm._v(" "), _c('el-button', {
    attrs: {
      "type": "primary",
      "disabled": _vm.addSubmitButtonDisabled,
      "loading": _vm.addLoading
    },
    nativeOn: {
      "click": function($event) {
        return _vm.addSubmit($event)
      }
    }
  }, [_vm._v("提交")])], 1)], 1)], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-57367256"}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/pages/system_setup/user_list.vue
// module id = 830
// module chunks = 1